import { Component } from '@angular/core';

/** Dummy route target for the chat view rendered by the app shell. */
@Component({
  template: '',
})
export class ChatPageComponent {}
